import script from "./create-post.vue?vue&type=script&setup=true&lang=js"
export * from "./create-post.vue?vue&type=script&setup=true&lang=js"

import "./create-post.vue?vue&type=style&index=0&id=fb758e26&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb758e26"]])

export default __exports__